<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QGAzSr/tc-custom/9781426832376.jpg?1708086995611" alt="This image is the cover for the book Valentino's Love-Child"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Valentino's Love-Child
      </h1>
      <p class="bookDescription body article font2">
        <b>Under the Sicilian sun, Valentino’s mistress tempts him like no other! A blazing-hot romance from the <i>USA Today</i>–bestselling author.</b><br/><br/>Their relationship is scorching, its intensity unmatched, the desire indescribable. Only, love can never be mentioned . . . <br/><br/>But Faith Williams—Valentino Grisafi’s stunning, intriguing American lover—is testing his resolve. He said he’d never marry again, that his principles won’t allow it.<br/><br/>The one person to tame the untamable Valentino is Faith—the woman who’s carrying his child . . . <br/><br/><b>“Monroe has set a new standard for Harlequin Presents. It will be hard for others to reach her level now . . . I felt like I was in Sicily while lost in the pages of this romantic tale . . . Be sure to check out this heartwarming read!” —<i>Fresh Fiction</i></b><br/><br/><b>“Lucy Monroe has a fabulous love story on her hands with <i>Valentino’s Love-Child</i>. Faith is a heroine readers will relate too on so many levels and Valentino is her perfect hero.” —<i>Fallen Angel Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucy  Monroe
      </h2>
      
      <p class="authorDescription body article">USA Today Bestseller Lucy Monroe finds inspiration for her stories everywhere as she is an avid people-watcher. She has published more than fifty books in several subgenres of romance and when she&#39;s not writing, Lucy likes to read. &#160;She&#39;s an unashamed book geek, but loves movies and the theatre too. She adores her family and truly enjoys hearing from her readers! Visit her website at: http://lucymonroe.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8162fcae